'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import {
  SvgAchievement,
  SvgBlank,
  SvgBook,
  SvgChat,
  SvgHand,
  SvgIon,
  SvgJam,
  SvgPill,
  SvgTags, SvgTel,
} from '../icons';
import s from './dropdown.module.scss';

export const Dropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  return (
    <div className={s.dropdown} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <button className={s.dropdownToggle}>
        <SvgIon />
        <SvgHand />
        <SvgJam />
        <SvgBook />
        <SvgAchievement />
        <SvgTags />
        <SvgPill />
        <SvgBlank />
        <SvgChat />
        <SvgTel />
      </button>
      {isOpen && (
        <ul className={s.dropdownMenu}>
          <li><Link scroll={false} href="/about_clinic">О нас</Link></li>
          <li><Link href="/services">Услуги</Link></li>
          <li><Link href="/doctors">Врачи</Link></li>
          <li><Link href="/analyses">Анализы</Link></li>
          <li><Link href="/patients">Пациентам</Link></li>
          <li><Link href="/promotions">Акции</Link></li>
          <li><Link href="/news">Новости</Link></li>
          <li><Link href="/articles">Статьи</Link></li>
          <li><Link href="/testimonials">Отзывы</Link></li>
          <li><Link href="/contacts">Контакты</Link></li>
        </ul>
      )}
    </div>
  );
};
